import { AfterViewInit, Component, inject, Input, OnInit, ViewChild } from '@angular/core'
import { CommonModule, NgIf } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IonicModule } from '@ionic/angular'
import { ExtendedFabComponent } from '../../../components/extended-fab/extended-fab.component'
import { InfoBarComponent } from '../../../components/info-bar/info-bar.component'
import { Assistance } from '../../../models/assistance'
import { IonTextarea, ModalController } from '@ionic/angular'
import { AssistantAssignment } from '../../../models/assistantAssignment'

@Component({
  selector: 'app-role-assistant-assistance-feedback',
  templateUrl: './role-assistant-assistance-feedback.component.html',
  styleUrls: ['./role-assistant-assistance-feedback.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule, ExtendedFabComponent, InfoBarComponent, NgIf],
})
export class RoleAssistantAssistanceFeedbackComponent implements OnInit, AfterViewInit {
  private modalCtrl = inject(ModalController)

  @Input() assistance: Assistance
  @Input() assignment: AssistantAssignment
  @ViewChild('feedbackInput') feedbackInput: IonTextarea

  TAG = 'RoleAssistantAssistanceFeedbackComponent'

  feedback: string

  ngOnInit() {
    console.log(this.TAG, 'assistance', this.assistance)
    this.feedback = this.assignment.assistantFeedback
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.feedbackInput.setFocus()

      // Puts cursor at the end of the textarea field (according to https://stackoverflow.com/a/56719955/3158815)
      this.feedbackInput.getInputElement().then((el) => el.setSelectionRange(-1, -1))
    }, 400)
  }

  async dismissModal(returnFeedback?: string) {
    await this.modalCtrl.dismiss(returnFeedback)
  }

  save() {
    this.dismissModal(this.feedback)
  }
}
